import Share from '../src/Share';
export default Share;
